import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Head: {
    Type: "SHELF TAG",
    SheetNo: "",
  }, 
   
};

const SliceBarcodeScanning = createSlice({
  name: "SliceBarcodeScanning",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },  
    
    Barcode_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  Head_Set,
  Barcode_Init 
} = SliceBarcodeScanning.actions;
export default SliceBarcodeScanning.reducer;
